import { graphql, useStaticQuery } from 'gatsby';

const useAllWorkshops = () => {
  const { allContentfulWorkshop } = useStaticQuery(graphql`
    {
      allContentfulWorkshop(filter: { hidden: { ne: true } }, sort: { title: ASC }) {
        edges {
          node {
            ...Workshop
          }
        }
      }
    }
  `);

  return allContentfulWorkshop?.edges.map((x) => x.node);
};

export default useAllWorkshops;
